import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { ServiceCover } from "@/components/organisms/ServiceCover";
import { ServiceList } from "@/components/organisms/ServiceList";
import { ServiceNav } from "@/components/organisms/ServiceNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";

export default function ServicePage(props) {
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"事業内容"}
        pageDescription={
          "株式会社トッカシステムズの事業内容です。AI開発支援ツールを活用した最新のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/about/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            {/* <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Product",
                },
              ]}
            /> */}
            <Inner className="max-w-full">
              <ServiceCover />
              <ServiceNav />
              <ServiceList />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Careers />
        <Footer />
      </Layout>
    </>
  );
}
